/** Enumeration of valid data types. */
export default {
    STRING: "STRING",
    DATE: "DATE",
    DECIMAL: "DECIMAL",
    INTEGER: "INTEGER",
    BOOLEAN: "BOOLEAN",
    STRING_ARRAY: "STRING_ARRAY"
};
